import React from 'react';
import { Navigate, Route, Routes, useNavigate, useParams } from 'react-router-dom';
import { Affix, Layout } from 'antd';
import { QueryDetail, QueryOrder, getObjectDisplay, useAuth, useMetaContext, useTranslateContext, useUserConfigContext, useUserContext } from 'fennec-ui';
import { useDispatch, useSelector } from 'react-redux';

import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import SideMenu from '../../../components/SideMenu';

import CommonMainMyaccount from '../../CommonMainMyaccount';
import CommonMainOrders from '../../CommonMainOrders';
import { access, defaultRoute } from '../../../../common/Tool';
import FederationadministratorManagementAccounts from '../../FederationadministratorManagementAccounts';
import FederationadministratorManagementDvizheniedeneg from '../../FederationadministratorManagementDvizheniedeneg';
import FederationadministratorManagementUserinfo from '../../FederationadministratorManagementUserinfo';
import FederationadministratorManagementEkvairing from '../../FederationadministratorManagementEkvairing';
import { BreadcrumbsProvider, MenuLevelThreeContext, MenuLevelThreeElementContext, useIsDesktopOrLaptopContext, useIsMobileContext, useLayoutWidthContext } from '../../../../common/Context';
import LevelBreadcrumbs from '../../../components/LevelBreadcrumbs';
import FederationadministratorManagementNews from '../../FederationadministratorManagementNews';
import FederationadministratorManagementAttestation, { Attestation, AttestationList } from '../../FederationadministratorManagementAttestation';
import ContextRoute from '../../ContextRoute';
import { ContextTestingAdminElement, ContextTestingElement } from '../../../components/ContextElement';
import FederationadministratorManagementSavingsaccount from '../../FederationadministratorManagementSavingsaccount';
import FederationadministratorPostsVsetipipolzovatelei from '../../FederationadministratorPostsVsetipipolzovatelei';
import FederationadministratorManagementExtendedProperties from '../../FederationadministratorManagementExtendedProperties';
var isBetween = require('dayjs/plugin/isBetween')
var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(isBetween)
dayjs.locale('ru');

export default function Management(props) {
    let { id } = useParams();
    const dispatch = useDispatch();
    let navigate = useNavigate();
    const auth = useAuth();
    const t = useTranslateContext();
    const user = useUserContext();
    const meta = useMetaContext();
    const [userConfig, setUserConfig] = useUserConfigContext();
    // const langSwitch = useLangSwitchContext();

    const siteAccess = useSelector(state => state.siteAccess.value);

    const role_by_id = useSelector(state => state.home.role_by_id);
    const status = useSelector(state => state.home.status, () => { }); // Статусы
    const notify = useSelector(state => state.home.notify, () => { }); // Уведомления

    const { menu: m } = props;

    const menu = (status, notify) => {
        const x = [
            {
                uuid: "accounts",
                name: "Счета",
                default: true,
                component: (props) => (<FederationadministratorManagementAccounts {...props} auth={auth} />),
                role: [
                    { "ID": 5, "nazvanie": "ПрезидентФедерации" },
                    { "ID": 9, "nazvanie": "АдминистраторФедерации" },
                ]
            },
            {
                uuid: "dvizheniedeneg",
                name: "Движения денег",
                default: true,
                component: (props) => (<FederationadministratorManagementDvizheniedeneg {...props} auth={auth} />),
                role: [
                    { "ID": 5, "nazvanie": "ПрезидентФедерации" },
                    { "ID": 9, "nazvanie": "АдминистраторФедерации" },
                ]
            },
            {
                uuid: "news",
                name: "Новости",
                default: true,
                component: (props) => (<FederationadministratorManagementNews {...props} auth={auth} />),
                role: [
                    { "ID": 5, "nazvanie": "ПрезидентФедерации" },
                    { "ID": 9, "nazvanie": "АдминистраторФедерации" },
                ]
            },
            {
                uuid: "userinfo",
                name: "Тех. информация",
                component: (props) => (<FederationadministratorManagementUserinfo {...props} auth={auth} />),
                role: [
                    { "ID": 5, "nazvanie": "ПрезидентФедерации" },
                    { "ID": 9, "nazvanie": "АдминистраторФедерации" },
                ]
            },
            {
                uuid: "ekvairing",
                name: "Эквайринг",
                component: (props) => (<FederationadministratorManagementEkvairing {...props} auth={auth} />),
                role: [
                    { "ID": 5, "nazvanie": "ПрезидентФедерации" },
                    { "ID": 9, "nazvanie": "АдминистраторФедерации" },
                ]
            },
            // {
            //     uuid: "attestation",
            //     name: "Судейская аттестация",
            //     component: (props) => (<FederationadministratorManagementAttestation {...props} auth={auth} />),
            //     role: [
            //         { "ID": 5, "nazvanie": "ПрезидентФедерации" },
            //         { "ID": 9, "nazvanie": "АдминистраторФедерации" },
            //     ]
            // },
            {
                uuid: "attestation",
                name: "Судейская аттестация",
                // color: "#a2d2ff",
                component: (props) => (
                    <ContextRoute uuid=":id"
                        display={(item) => (<div style={{ width: "100%" }}><ContextTestingAdminElement item={item} /></div>)}
                        displayString={(item) => {
                            return getObjectDisplay(item, "TestiSudeiskikhAttestatsii", meta)
                        }}
                        params={[
                            QueryOrder("ID", "ASC"),
                            QueryDetail("collection")
                        ]}
                        listSource="/api/query/testisudeiskikhattestatsii"
                        list={<AttestationList {...props} />}

                        itemSource="/api/query/testisudeiskikhattestatsii"
                        // item={<Attestation {...props} />}
                        item={<Attestation {...props} />}
                    />),
                role: [
                    { "ID": 5, "nazvanie": "ПрезидентФедерации" },
                    { "ID": 9, "nazvanie": "АдминистраторФедерации" },
                ],
            },
            {
                uuid: "savings-account",
                name: "Накопительные счета",
                default: true,
                component: (props) => (<FederationadministratorManagementSavingsaccount {...props} auth={auth} />),
                role: [
                    { "ID": 5, "nazvanie": "ПрезидентФедерации" },
                    { "ID": 9, "nazvanie": "АдминистраторФедерации" },
                ]
            },
            {
                uuid: "extended-properties",
                name: "Дополнительные параметры пользователей",
                component: (props) => (<FederationadministratorManagementExtendedProperties {...props} auth={auth} />),
                role: [
                    { "ID": 5, "nazvanie": "ПрезидентФедерации" },
                    { "ID": 9, "nazvanie": "АдминистраторФедерации" },
                ]
            },
            // {
            //     uuid: "createrposts",
            //     name: "Создатели постов",
            //     default: true,
            //     component: (props) => (<FederationadministratorPostsVsetipipolzovatelei {...props} auth={auth} />),
            //     role: [
            //         { "ID": 5, "nazvanie": "ПрезидентФедерации" },
            //         { "ID": 9, "nazvanie": "АдминистраторФедерации" },
            //     ]
            // },
        ]
        return x
    };

    const [layoutWidth, setLayoutWidth] = useLayoutWidthContext();
    const isMobile = useIsMobileContext();
    const isDesktopOrLaptop = useIsDesktopOrLaptopContext();

    return (
        <MenuLevelThreeContext.Provider value={menu(status, notify)}>
            {(!siteAccess || siteAccess == "allow") && <Routes>
                {defaultRoute(menu(status, notify), role_by_id)}
                {menu(status, notify).map((e, idx) => {
                    if (e.component && access(e, role_by_id)) {

                        return <Route key={e.uuid} path={(e.uuid !== "*") ? e.uuid + "/*" : "*"} element={
                            <BreadcrumbsProvider value={{
                                // parent: props?.level,
                                uuid: e?.uuid,
                                name: e?.name,
                                color: e?.color,
                                role: e?.role,
                                hidden: e.hidden
                            }}>
                                {e.component({})}
                            </BreadcrumbsProvider>} />

                    }
                })}
            </Routes>}
        </MenuLevelThreeContext.Provider>
    );
}
